module.exports = __webpack_public_path__ + "static/media/24.cb2616bc.webp";